import clsx from 'clsx';
import type { MouseEvent } from 'react';
import { Icon } from '../icon/icon.component';
import { Text } from '../text/text.component';
import { type Style, mergeStyle } from './option.module.css';

interface Props {
  style?: Style;
  text: string;
  icon?: string;
  hiddeIcon?: boolean;
  disabled?: boolean;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
}

export function Option(props: Props) {

  const {
    text,
    icon = '',
    hiddeIcon = false,
    disabled = false,
    style: customStyle,
    onClick
  } = props;

  const style = mergeStyle(customStyle);

  function handleClick(event?: MouseEvent<HTMLDivElement>) {
    if (!disabled) {
      onClick?.(event);
    }
  }

  return (
    <div 
      className={clsx(style.container, disabled && style.containerDisabled)}
      onClick={handleClick}>
      {!hiddeIcon && 
        <Icon 
          className={clsx(style.icon, disabled && style.iconDisabled)}
          icon={icon}/> 
      }
      <Text 
        className={clsx(style.text, disabled && style.textDisabled)} 
        text={text}/>
    </div>
  );
}
